import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { useInvoiceStore } from '../stores/invoiceStore';
import { LANGUAGE_NAMES } from '../constants/languages';

export const LanguageNotice: React.FC = () => {
  const { t, locale: interfaceLanguage } = useTranslation();
  const { settings: { language: invoiceLanguage } } = useInvoiceStore();

  // Only show if languages differ
  if (interfaceLanguage === invoiceLanguage) {
    return null;
  }

  return (
    <div className="text-xs text-gray-500 bg-gray-50 rounded-lg p-2 border border-gray-100">
      <span>
        {t('settings.languageNotice', {
          interfaceLanguage: LANGUAGE_NAMES[interfaceLanguage],
          invoiceLanguage: LANGUAGE_NAMES[invoiceLanguage]
        })}
      </span>
    </div>
  );
};

export default LanguageNotice; 